import { Compass, Users, Mountain, Sun, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { DomainChart } from "@/components/DomainChart";

const DOMAINS = [
  [Compass, "New Possibilities", "Developing new interests, choosing a fresh life path, or realigning personal goals and priorities.", "lg:col-span-2"],
  [Users, "Relating to Others", "Cultivating closer, more honest relationships, accepting help more easily, and building deeper empathy for others' suffering.", "lg:col-span-2"],
  [Mountain, "Personal Strength", "A hard-won sense of self-reliance, realizing \u201cif I can survive that, I can handle anything life throws at me.\u201d", "lg:col-span-2"],
  [Sun, "Appreciation for Life", "A fundamental shift in perspective where the individual feels immense gratitude for everyday moments and simple things.", "lg:col-span-3"],
  [Sparkles, "Spiritual or Existential Change", "Grappling with profound questions (\u201cWho am I?\u201d, \u201cWhy am I here?\u201d) to develop stronger faith, a deeper connection to nature, or a revised inner peace.", "lg:col-span-3"],
];

const muted = { color: "var(--kh-text-muted)" };

export const Domains = () => (
  <section className="px-6 sm:px-10 lg:px-14 py-24 lg:py-32" data-testid="domains-section">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <Reveal className="lg:col-span-6">
        <div className="kh-mono mb-4">Measuring transformation</div>
        <h2 className="kh-serif text-4xl lg:text-5xl leading-[1.05]">Five domains of Post-Traumatic Growth</h2>
        <p className="mt-6 text-base sm:text-lg leading-relaxed" style={muted}>As individuals progress through the steps above, experts measure their true transformation across five core psychological domains using the Post-Traumatic Growth Inventory (PTGI):</p>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-6 px-10 sm:px-16">
        <DomainChart />
      </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6">
        {DOMAINS.map(([Icon, title, text, span], i) => (
          <Reveal key={title} delay={(i % 3) * 0.1} className={`h-full ${span} ${i === 4 ? "md:col-span-2" : ""}`}>
            <div className="kh-card kh-card-hover h-full group" data-testid={`domain-${i + 1}`}>
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-full flex items-center justify-center transition-colors duration-300 group-hover:bg-[var(--kh-accent)] group-hover:text-white" style={{ border: "1px solid var(--kh-accent-soft)", color: "var(--kh-accent)" }}>
                  <Icon size={20} strokeWidth={1.5} />
                </span>
                <span className="kh-mono">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="kh-serif text-2xl mt-8">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed" style={muted}>{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
